<template>
    <BrandPage :content="content" />
</template>

<script>
import BrandPage from "./BrandPage.vue";
import content from "./content/prosafety.yaml";

export default {
    components: { BrandPage },
    data: () => ({ content }),
};
</script>
